<template>
  <!-- <div>
		<a href="#" v-on:click="shareToFacebook()" style="float:left; padding-right: 20px;">
			<img src="http://osc.scmp.com/images/btn_fb_share_50x24.png" />
		</a>
		<iframe :src="'//www.facebook.com/plugins/like.php?href='+ url +'&send=false&layout=standard&width=450&show_faces=true&action=like&colorscheme=light&font&height=80&appId=352807764806719&locale='+locale" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:350px; height:22px;max-width: 100%;vertical-align: middle;" allowTransparency="true"></iframe>
	</div> -->
  <iframe
    :src="'//www.facebook.com/plugins/like.php?href='+ url +'&send=false&layout=standard&width=450&show_faces=false&share=true&action=like&colorscheme=light&font&height=80&appId=1469600923317701&locale='+locale"
    scrolling="no"
    frameborder="0"
    style="border:none; overflow:hidden; width:100%; height:22px;max-width: 100%;vertical-align: middle;"
    allowTransparency="true"
  />
</template>
<script>
export default {
	name: "ShareBtn",
	data() {
		return {
			locale: this.$i18n.locale == "en" ? "en_US" : "zh_HK",
			// url: encodeURIComponent(location.href)
			url: encodeURIComponent(location.pathname? "http://osc.scmp.com"+location.pathname: "http://osc.scmp.com")
		};
	},
	methods: {
		shareToFacebook() {
			window.open("https://www.facebook.com/sharer/sharer.php?u=" + this.url, "facebook-share-dialog", "width=626,height=436");
			return false;
		}
	}
};
</script>